import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const ClaimDetailSearchSchema = z.object({
  card: z.string().optional().catch(undefined),
  search: z.string().optional().catch(undefined),
})

export type ClaimDetailSearch = z.infer<typeof ClaimDetailSearchSchema>

export const Route = createFileRoute(
  '/_authenticated/$workspaceId/claims/$claimId/'
)({
  validateSearch: (raw) => ClaimDetailSearchSchema.parse(raw),
})
